<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!user">
      <span class="loader"></span>
    </span>
    <div v-if="user" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="fa-regular fa-list"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <user-view-global
            @onDeactivateUser="onDeactivateUser"
            @onActivateUser="onActivateUser"
            :user="user"
            @onUpdateUser="onUpdateUser"
          />
        </tab-pane>

        <!-- <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-history"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <user-view-logs :user="user" />
        </tab-pane> -->
      </tabs>
    </div>
  </div>
</template>

<script>;
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import UserViewGlobal from "../partials/UserViewGlobal.vue";
import UserViewAuthorizations from "../partials/UserViewAuthorizations.vue";
import UserViewLogs from "../partials/UserViewLogs.vue";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    UserViewGlobal,
    UserViewAuthorizations,
    UserViewLogs,
    ListFileComponent,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      user: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("users/get", this.userId);
        this.user = this.$store.getters["users/user"];
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editUser(row) {
      this.$router.push({
        name: "Edit User",
        params: { id: this.user.id },
      });
    },

    async deleteUser() {
      const confirmation = await swal.fire({
        title: this.$t("USERS.DELETE_THIS_USER"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch("users/destroy", this.user.id);
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("USERS.USER_DELETED"),
          });
          await this.goBack();
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List Users" });
    },

    async activateUser() {
      try {
        this.loading = true;
        await this.$store.dispatch("users/activate", this.user.id);
        this.user = this.$store.getters["users/user"];
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_ACTIVATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async deactivateUser() {
      try {
        this.loading = true;
        await this.$store.dispatch("users/deactivate", this.user.id);
        this.user = this.$store.getters["users/user"];
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_DEACTIVATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    onDeactivateUser() {
      this.$emit("onDeactivateUser", this.user);
    },

    onActivateUser() {
      this.$emit("onActivateUser", this.user);
    },

    onUpdateUser() {
      this.$emit("onEditUser", this.user);
    },
  },
};
</script>
